import React, { useEffect, useState } from 'react';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <div className={className} data-id="element-314">{children}</div>;
export const Button = ({
  href,
  children,
  variant = 'primary',
  className = '',
  onClick
}: {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  onClick?: () => void;
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-6 md:px-10 py-5 rounded-full font-sans font-black transition-all duration-500 transform hover:scale-105 active:scale-95 shadow-2xl text-center leading-tight tracking-wide uppercase';
  const variants = {
    primary: 'bg-gradient-to-r from-orange-600 via-orange-500 to-amber-500 text-white hover:shadow-[0_0_40px_rgba(249,115,22,0.4)] relative overflow-hidden group border-b-4 border-orange-700/80',
    secondary: 'bg-navy-800 text-white border border-white/20 hover:bg-navy-700 hover:border-orange-500/50 backdrop-blur-md'
  };
  return <a href={href} className={`${baseStyle} ${variants[variant]} ${className}`} onClick={onClick} data-id="element-315">
      {variant === 'primary' && <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-shine" data-id="element-316" />}
      <span className="relative z-10 drop-shadow-md" data-id="element-317">{children}</span>
    </a>;
};
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 16,
    seconds: 48
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-318">
      <div className="relative bg-navy-900/80 px-4 md:px-6 py-4 md:py-5 rounded-2xl border border-orange-500/20 shadow-[0_8px_30px_rgba(0,0,0,0.4)] min-w-[70px] md:min-w-[90px] overflow-hidden group backdrop-blur-sm" data-id="element-319">
        {/* Subtle top highlight */}
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-400/30 to-transparent" data-id="element-320" />
        <div className="absolute inset-0 bg-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-321"></div>

        <div className="relative flex justify-center items-center h-10 md:h-14" data-id="element-322">
          <span className="text-4xl md:text-6xl font-mono font-black text-orange-500 tracking-tighter drop-shadow-[0_0_12px_rgba(249,115,22,0.3)]" data-id="element-323">
            {format(value)}
          </span>
        </div>
      </div>
      <span className="text-[10px] md:text-[12px] text-gray-400 uppercase font-black tracking-[0.2em] mt-4 opacity-90" data-id="element-324">
        {label}
      </span>
    </div>;
  return <div className="flex items-start justify-center space-x-2 md:space-x-4" data-id="element-325">
      <TimeUnit value={timeLeft.hours} label="horas" data-id="element-326" />
      <div className="text-orange-500/40 text-2xl md:text-4xl font-light pt-3 md:pt-5 animate-pulse" data-id="element-327">
        :
      </div>
      <TimeUnit value={timeLeft.minutes} label="minutos" data-id="element-328" />
      <div className="text-orange-500/40 text-2xl md:text-4xl font-light pt-3 md:pt-5 animate-pulse" data-id="element-329">
        :
      </div>
      <TimeUnit value={timeLeft.seconds} label="segundos" data-id="element-330" />
    </div>;
};